import React from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import StatisticsCard from "../statisticsCard/StatisticsCard";
import AddIcon from "@material-ui/icons/Add";
import CachedIcon from '@material-ui/icons/Cached';
import CheckIcon from '@material-ui/icons/Check';
import BlockIcon from '@material-ui/icons/Block';
import CloseIcon from '@material-ui/icons/Close';
import { Link } from "react-router-dom";
import "./statisticsWrapper.scss"

const StatisticsWrapper = ({ intl: { messages }, statistics }) => {
  const user = useSelector((state) => state.auth?.user?.data);

  if (!user) return null

  return (
    <div className={`d-md-flex justify-content-between px-0`}>
      <Link to={"/newRequests"} className="statistics-box">
        <StatisticsCard
          number={statistics?.new}
          title={messages.statistics.new}
          icon={<AddIcon className="icon-wrapper_icon" />}
          classes="new"
        />
      </Link>
      <Link to={"/activeRequests"} className="statistics-box">
        <StatisticsCard
          number={statistics?.inprogress}
          title={messages.statistics.active}
          icon={<CachedIcon className="icon-wrapper_icon" />}
          classes="active"
        />
      </Link>
      <Link to={"/completedRequests"} className="statistics-box">
        <StatisticsCard
          number={statistics?.completed}
          title={messages.statistics.completed}
          icon={<CheckIcon className="icon-wrapper_icon" />}
          classes="completed"
        />
      </Link>
      <Link to={"/canceledRequests"} className="statistics-box">
        <StatisticsCard
          number={statistics?.canceled}
          title={messages.statistics.canceled}
          icon={<BlockIcon className="icon-wrapper_icon" />}
          classes="canceled"
        />
      </Link>
      <Link to={"/rejectedRequests"} className="statistics-box">
        <StatisticsCard
          number={statistics?.rejected}
          title={messages.statistics.rejected}
          icon={<CloseIcon className="icon-wrapper_icon" />}
          classes="rejected"
        />
      </Link>      
    </div>
  );
};

export default injectIntl(StatisticsWrapper);
